exports.getQAUrl = () => (window.goodway.NODE_ENV === 'production' ? 'https://qa.goodwaygroup.com/' : 'https://qa.staging.goodwaygroup.com/');



// WEBPACK FOOTER //
// ./src/helpers/qa.js